// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsTable__root--31q02"};